import { render, staticRenderFns } from "./HealthcareInvestor.vue?vue&type=template&id=2579837e&scoped=true&"
import script from "./HealthcareInvestor.vue?vue&type=script&lang=js&"
export * from "./HealthcareInvestor.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareInvestor.vue?vue&type=style&index=0&id=2579837e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579837e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VRow})
